module.exports = {
  api: process.env.REACT_APP_API_BASE_URL || '/v1',
  yearFrom: 2020,
  yearTo: 2030,
  progressStatus: ["info", "daydream", "activities", "competencies", "occupations", "self1", "self2", "done"],
};
